import { render } from "./HeroiconsOutlinePresentationChartLine.vue?vue&type=template&id=47615ec9"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePresentationChartLine.vue"]])

export default __exports__